// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Breadcrumbs from '@/components/breadcrumbs';
import Storage from '@/utils/storage';
import { Box, Card } from '@mantine/core';
import PurchasesTable from "@/PageComponents/Table/Component Tables/PurchasesTable";
import SCMessageBarContext from '@/utils/contexts/sc-message-bar-context';
import constants from '@/utils/constants';
import { createFileRoute } from '@tanstack/react-router'



function PurchaseList() {

    const messageBarContext = useContext(SCMessageBarContext);

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, '/');
        }
    }, [accessStatus]);

    return (
        <>
            <Box
                mt={'var(--mantine-spacing-sm)'}
                px={'var(--mantine-spacing-md)'}
                mb={0}
                pb={0}
                style={(theme: any) => ({ borderBottom: `${theme.colors.gray[2]} 2px solid` })}
            >
                <Box my={'var(--mantine-spacing-md)'}>
                    <Breadcrumbs
                        currPage={{
                            text: 'Purchase List',
                            link: `/purchase/list`,
                            type: 'list',
                        }}
                    />
                </Box>
            </Box>
            <Box
                h={`calc(100vh - 100px${((messageBarContext as any)?.isActive ? ` - ${constants.messageBarMargin}px` : "")})`}
                style={(theme: any) => ({
                    backgroundColor: theme.colors.gray[1],
                })}
                p={'var(--mantine-spacing-xs)'}
                pb={constants.chatWidgetSafeArea}
            >
                <Card
                    style={{
                        backgroundColor: 'white',
                    }}
                    p={'var(--mantine-spacing-md)'}
                    radius={'md'}
                >
                    <PurchasesTable />
                </Card>
            </Box>
        </>
    );
}

export default PurchaseList;

export const Route = createFileRoute('/_authenticated/purchase/list')({ component: PurchaseList })
